var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwLite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1:130)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.4,
    cy: 22.3805,
    r: 16.7999,
    fill: "#F53838"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 5.58057C26.1215 5.58057 18.6 13.1021 18.6 22.3806C18.6 31.6591 26.1215 39.1806 35.4 39.1806C44.6785 39.1806 52.2 31.6591 52.2 22.3806C52.2 13.1021 44.6785 5.58057 35.4 5.58057ZM42.2337 19.3426C42.2407 19.4861 42.2425 19.6296 42.2425 19.7696C42.2425 24.1446 38.9157 29.1863 32.8292 29.1863C31.0307 29.1893 29.2697 28.6728 27.7577 27.6988C28.015 27.7303 28.2792 27.7426 28.547 27.7426C30.0975 27.7426 31.5237 27.2158 32.656 26.3268C31.966 26.3133 31.2974 26.0848 30.7434 25.6732C30.1894 25.2617 29.7777 24.6875 29.5655 24.0308C30.061 24.125 30.5715 24.1053 31.0582 23.9731C30.3093 23.8216 29.6358 23.4158 29.152 22.8245C28.6681 22.2331 28.4037 21.4926 28.4035 20.7286V20.6883C28.8497 20.9351 29.3607 21.0856 29.9032 21.1031C29.2011 20.6357 28.7041 19.9177 28.5138 19.0961C28.3235 18.2744 28.4543 17.411 28.8795 16.6826C29.7106 17.7046 30.7472 18.5406 31.922 19.1366C33.0968 19.7326 34.3836 20.0752 35.6992 20.1423C35.532 19.4324 35.604 18.687 35.904 18.0222C36.204 17.3574 36.7153 16.8103 37.3584 16.466C38.0014 16.1218 38.7402 15.9996 39.4598 16.1185C40.1794 16.2374 40.8396 16.5907 41.3377 17.1236C42.0783 16.9771 42.7884 16.7054 43.4377 16.3203C43.1909 17.0871 42.6742 17.7381 41.9835 18.1526C42.6395 18.0736 43.28 17.8972 43.884 17.6293C43.4403 18.2941 42.8815 18.8743 42.2337 19.3426Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1:130",
    x: 0.600098,
    y: 0.580566,
    width: 69.5999,
    height: 69.5999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0658854 0 0 0 0 0.0730469 0 0 0 0 0.1375 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1:130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1:130",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwLite);
export default __webpack_public_path__ + "static/media/tw-lite.8d36da8c.svg";
export { ForwardRef as ReactComponent };